<script>
    import Scene from "./Scene.svelte";
    import Path from "../pre-comps/Elements/Path.svelte";
    import PathTooltips from "../pre-comps/Elements/PathTooltips.svelte";

    const layers = [
        Path,
        PathTooltips,
    ];
</script>

<Scene layers={layers}></Scene>